import { useEffect } from "react";

export default function RevealOnScroll() {
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
        );
        els.forEach((el) => io.observe(el));

        // observe added later via MutationObserver
        const mo = new MutationObserver(() => {
            document
                .querySelectorAll(".reveal:not(.in)")
                .forEach((el) => io.observe(el));
        });
        mo.observe(document.body, { childList: true, subtree: true });

        return () => {
            io.disconnect();
            mo.disconnect();
        };
    }, []);
    return null;
}
